import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import SpotlightResource from '@/modules/spotlight/resources/SpotlightResource';
import { SpotlightGroupCollection } from '@/modules/spotlight/models/SpotlightGroupCollection';
import { SpotlightSearchParams } from '@/modules/spotlight/models/SpotlightSearchParams';

export class SpotlightService extends BaseService {
  resource: typeof SpotlightResource;

  constructor() {
    super();

    this.resource = SpotlightResource;
  }

  async search(params: SpotlightSearchParams): Promise<SpotlightGroupCollection> {
    return SpotlightGroupCollection.mapModel(await this.resource.search(params));
  }
}

export default new SpotlightService();
